/* eslint-disable promise/param-names */
import {
  CONFIGURATION_REQUEST,
  CONFIGURATION_COMMIT,
  CONFIGURATION_SUCCESS,
} from '@/store/actions/configuration';

import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/storage';

import querystring from 'querystring-browser';
import moment from 'moment';

import Vue from 'vue';
import {sleep} from '@/utils/utils.js'

const state = { 
  configuration: [],
  status: ''
};

const getters = {
  configuration: state => state.configuration ? state.configuration : '',
  configurationLoading: state => state.status == 'loading',
  configurationLoaded: state => { 
    return state.hasLoadedOnce
  }
};

const actions = {
  [CONFIGURATION_REQUEST]: ({commit}) => {
    return new Promise((resolve) => {
      commit(CONFIGURATION_REQUEST)

      firebase.firestore().collection('props').doc('ui').get()
          .then(documentSnapshot => {
            if (documentSnapshot.exists) {
              commit(CONFIGURATION_SUCCESS, documentSnapshot.data());
              resolve();
            }

            commit(CONFIGURATION_SUCCESS);
            resolve('');
          })
    })
  },
 
  [CONFIGURATION_COMMIT]: ({commit}, cfg) => {
    commit(CONFIGURATION_REQUEST)

    firebase.firestore().collection('props').doc('ui').update({
      header_bg_color: cfg.header_bg_color,
      google_ads_script: cfg.google_ads_script,
    })
        .then(() => {
          commit(CONFIGURATION_SUCCESS);
        })
  },
}

const mutations = {
  [CONFIGURATION_REQUEST]: (state) => {
    state.status = 'loading';
  },

  [CONFIGURATION_SUCCESS]: (state, configuration) => {
    state.status = 'success'

    if (configuration !== undefined) {
      state.configuration = configuration;
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
